import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const calendarWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/calendar', component: () => import('./pages/CalendarPage.js') },
    { path: '/calendar/rooms', component: () => import('./pages/RoomsPage.js') },
  ],
  widgets: {
    'calendar.today': () => import('./TodayWidget.js'),
  },
});
